module.exports = __webpack_public_path__ + "img/news-4.c0a396b7.png";